<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-header-txt">{{$t('all_tests')}}</span>
        </div>

        <div class="search-wrapper">
          <img src="@/assets/images/search.svg" />
          <input class="search-input" type="text" :placeholder="$t('search_type')" v-model="searchTestText" v-on:keyup.enter="onEnter"/>
          <div v-if="searchTestText"  class="searchBarCross" @click="resetSearch">
            <img class="cross" src="../../assets/images/cross.svg" />
          </div>
        </div>

        <div class="program-list" v-scroll-end="loadMore">
          <div
              v-if="!initialLoading"
              class="program-row"
              v-for="item in tests"
              @click="() => checkTest(item)"
              :class="{
                'checked': isSelected(item.testId),
                'disabled': !canUnselectTest(item.testId)
              }"
          >

            <div class="program-left">
              <img
                  v-if="!isSelected(item.testId)"
                  src="@/assets/images/checkbox-circle.svg"
                  :style="!canUnselectTest(item.testId) ? 'opacity: 0.5; cursor: not-allowed;' : ''"
              />
              <img
                  v-else
                  src="@/assets/images/checkboxchecked-circle.svg"
                  :style="!canUnselectTest(item.testId) ? 'opacity: 0.5; cursor: not-allowed;' : ''"
              />
              <img v-if="item.avatarUrl !== null" :src="item.avatarUrl" class="program-image" />

              <div class="program-info">
                <span class="program-title">{{item.name}}</span>

                <div style="margin-top: 5px">
                  <span class="program-tag"  v-for="tag in item.tags">{{tag.name}}</span>
                </div>
              </div>
            </div>

            <div class="program-right">
              <img src="@/assets/images/calendarGray.svg" class="program-info-icon" />
              <span class="program-date-text">{{formatDate(item.startAt)}}</span>
              -
              <span class="program-date-text">{{formatDate(item.finishAt)}}</span>
            </div>
          </div>

          <div v-if="isLoading || initialLoading" class="loading-center">
            <VueSpinner size="32" />
          </div>

        </div>


        <button class="dark-button w-100 mt-2" @click="onSave">
          <span v-if="!addLoading">{{$t('assign')}}</span>
          <VueSpinnerIos v-if="addLoading" size="20" height="100%" color="#fff" />
        </button>
        <div @click="this.handleClose" class="close-btn">
          <img class="cross" src="../../assets/images/cross.svg" />
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import {
  VueSpinner,
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import testService from "@/service/testService";
import depService from "@/service/depService";

export default {
  components: {
    TextInput,
    VueSpinner,
    VueSpinnerIos
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    preData: {
      type: Object,
      default: {}
    },
    type: {
      type: String,
      default: 'company'
    },
    refreshCallback: {
      type: Function,
      default: () => {}
    },
    selectedDepartment: {
      type: String,
      default: ""
    },
  },

  computed: {
    currentLocale() {
      const lang = localStorage.getItem('userLanguage') ||
          localStorage.getItem('language') ||
          localStorage.getItem('locale') ||
          this.$i18n?.locale ||
          'tr';
      return lang;
    }
  },

  data() {
    return {
      searchTestText: "",
      isLoading: true,
      tests: [],
      currentPage: 1,
      lastPage: false,
      data: {},
      assignIds: [],
      originalAssignIds: [],
      addLoading: false,
      lastLoadedDepartmentId: null,
      lastLoadedCompanyId: null,
      lastLoadedUserId: null,
      initialLoading: false,
      isLoadingAssigned: false,
      testsWithAssignType: {},
    };
  },

  mounted() {
    if (this.type !== 'department') {
      this.loadTests();
    }
  },

  watch: {
    '$route.query': {
      handler: function(newQuery, oldQuery) {
        if(this.$route.query.searchTestText){
          this.loadTests();
        }
      },
    },
    searchTestText: {
      handler: function() {
        if(this.searchTestText === "") {
          this.deleteSearch();
        }
      }
    },
    preData: {
      handler: function (val) {
        if (this.type !== 'department' && this.type !== 'user') {
          this.testsWithAssignType = {};
          if (val.tests && Array.isArray(val.tests)) {
            val.tests.forEach(test => {
              this.testsWithAssignType[test.testId] =
                  test.assignedType || test.assignType || 'company';
            });
          }

          this.originalAssignIds = val.tests ? val.tests.map(test => test.testId) : [];
          this.assignIds = [...this.originalAssignIds];
        }
      },
      immediate: true,
      deep: true
    },
    currentLocale: {
      handler(newLocale) {
        this.$forceUpdate();
      }
    },
    visible: {
      handler: function(isVisible) {
        if (isVisible) {
          if (this.type === 'department' && this.selectedDepartment) {
            if (this.lastLoadedDepartmentId !== this.selectedDepartment) {
              this.loadAssignedTests().then(() => {
                this.loadTests();
              });
              this.lastLoadedDepartmentId = this.selectedDepartment;
            }
          }
          else if (this.type === 'user' && this.preData?.userId) {
            if (this.lastLoadedUserId !== this.preData.userId) {
              this.initialLoading = true;
              this.loadUserAssignedTests()
                  .then(() => this.loadTests())
                  .finally(() => { this.initialLoading = false; });
              this.lastLoadedUserId = this.preData.userId;
            }
          }
          else if (this.type === 'company' && this.preData?.companyId) {
            if (this.lastLoadedCompanyId !== this.preData.companyId) {
              this.initialLoading = true;
              this.loadCompanyAssignedTests()
                  .then(() => this.loadTests())
                  .finally(() => { this.initialLoading = false; });
              this.lastLoadedCompanyId = this.preData.companyId;
            }
          }
        }
      }
    }
  },

  methods: {
    loadAssignedTests() {
      if (!this.selectedDepartment) return Promise.resolve();

      this.isLoadingAssigned = true;

      return depService.getAssignedItems(this.selectedDepartment, 'test')
          .then(response => {
            if (response.data.responseType === 'success' && response.data.data) {
              this.testsWithAssignType = {};
              const assignedTests = response.data.data;

              assignedTests.forEach(test => {
                this.testsWithAssignType[test.testId] =
                    test.assignedType || test.assignType || 'department';
              });

              this.originalAssignIds = assignedTests.map(test => test.testId);
              this.assignIds = [...this.originalAssignIds];

              this.tests = [...assignedTests];

            }
          })
          .catch(error => {
            handleErrorResponse(error, this.$snackbar);
          })
          .finally(() => {
            this.isLoadingAssigned = false;
          });
    },

    loadCompanyAssignedTests() {
      if (!this.preData?.companyId) return Promise.resolve();

      this.isLoadingAssigned = true;
      return testService.getCompanyTests(1, this.preData.companyId, [], '', 1000, 'test')
          .then(response => {
            if (response?.data?.responseType === 'success' && response.data.data) {
              const assignedTests = response.data.data.data || [];

              this.testsWithAssignType = {};
              assignedTests.forEach(test => {
                this.testsWithAssignType[test.testId] =
                    test.assignedType || test.assignType || 'company';
              });

              const apiAssignedIds = assignedTests.map(test => test.testId);

              const storeIds = this.preData.tests ? this.preData.tests.map(t => t.testId) : [];

              const allAssignedIds = [...new Set([...apiAssignedIds, ...storeIds])];

              this.originalAssignIds = allAssignedIds;
              this.assignIds = [...allAssignedIds];

              this.tests = [...assignedTests];
            }
          })
          .catch(error => {
            handleErrorResponse(error, this.$snackbar);
          })
          .finally(() => {
            this.isLoadingAssigned = false;
          });
    },

    loadUserAssignedTests() {
      if (!this.preData?.userId) return Promise.resolve();

      this.isLoadingAssigned = true;
      return testService.getUserTests(1, this.preData.userId, [], '', 1000, 'user')
          .then(response => {
            if (response?.data?.responseType === 'success' && response.data.data) {
              const assignedTests = response.data.data.data || [];

              this.testsWithAssignType = {};
              assignedTests.forEach(test => {
                this.testsWithAssignType[test.testId] =
                    test.assignedType || test.assignType || 'user';
              });

              this.originalAssignIds = assignedTests.map(test => test.testId);
              this.assignIds = [...this.originalAssignIds];

              this.tests = [...assignedTests];

            } else {
              this.originalAssignIds = [];
              this.assignIds = [];
              this.testsWithAssignType = {};
              this.tests = [];
            }
          })
          .catch(error => {
            if (error.response && error.response.status >= 400) {
              handleErrorResponse(error, this.$snackbar);
            }
          })
          .finally(() => {
            this.isLoadingAssigned = false;
          });
    },

    handleClose() {
      this.onHide();
      this.deleteSearch();
    },

    resetSearch() {
      this.searchTestText = "";
    },

    deleteSearch() {
      this.$router.push({
        query: {
          ...this.$route.query,
          searchTestText: undefined,
        }
      });
      this.loadTests();
    },

    onEnter() {
      this.$router.push({
        query: {
          ...this.$route.query,
          searchTestText: this.searchTestText,
        }
      });
    },

    checkTest(test) {
      const expectedType = this.type === 'department' ? 'department' :
          (this.type === 'company' ? 'company' : 'user');
      const actualType = this.testsWithAssignType[test.testId] || 'user';

      if (this.originalAssignIds.includes(test.testId) && actualType !== expectedType) {
        const displayType = this.$t(`assign_type_${actualType}`);

        let messageKey = '';
        if (actualType === 'company') {
          messageKey = 'test_assigned_from_company';
        } else if (actualType === 'department') {
          messageKey = 'test_assigned_from_department';
        } else if (actualType === 'user') {
          messageKey = 'test_assigned_from_user';
        } else {
          messageKey = 'test_assigned_from_other';
        }

        this.$snackbar.add({
          type: 'warning',
          text: this.$t(messageKey, { type: displayType }),
          timeout: 4000
        });
        return;
      }

      if (!test.isPublish && !this.originalAssignIds.includes(test.testId)) {
        this.$snackbar.add({
          type: 'warning',
          text: this.$t('test_not_published')
        });
        return;
      }

      if (this.assignIds.includes(test.testId)) {
        this.assignIds = this.assignIds.filter(item => item !== test.testId);
      } else {
        this.assignIds.push(test.testId);
      }
    },

    canUnselectTest(id) {
      if (!this.originalAssignIds.includes(id)) {
        return true;
      }

      if (this.type === 'department') {
        return this.testsWithAssignType[id] === 'department';
      } else if (this.type === 'company') {
        return this.testsWithAssignType[id] === 'company';
      } else {
        return this.testsWithAssignType[id] === 'user';
      }
    },

    isSelected(id) {
      return this.assignIds.includes(id);
    },

    loadMore() {
      if (!this.lastPage && !this.isLoading) {
        this.isLoading = true;
        this.currentPage++;
        this.loadScroll();
      }
    },

    loadScroll() {
      testService.getTests(this.currentPage).then(response => {
        this.data = response.data;
        if (response.data.data.last_page === this.currentPage) {
          this.lastPage = true;
        }
        this.tests = [...this.tests, ...response.data.data.data];
        this.isLoading = false;
      });
    },

    loadTests() {
      const tempFilters = [];
      this.currentPage = 1;
      const routeQuery = this.$route.query;

      if (routeQuery.searchTestText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchTestText
        });
      }

      tempFilters.push({ key: 'types[]', value: 1 });
      tempFilters.push({ key: 'types[]', value: 3 });

      return testService.getTests(this.currentPage, tempFilters).then(response => {
        this.data = response.data;
        const allTests = response.data.data.data;

        if (this.type === 'department' || this.type === 'company' || this.type === 'user') {
          const existingIds = this.tests.map(t => t.testId);
          const newTests = allTests.filter(t => !existingIds.includes(t.testId));
          this.tests = [...this.tests, ...newTests];
        } else {
          const assignedTests = allTests.filter(t => this.assignIds.includes(t.testId));
          const unassignedTests = allTests.filter(t => !this.assignIds.includes(t.testId));
          this.tests = [...assignedTests, ...unassignedTests];
        }

        this.isLoading = false;
      }).catch(error => {
        this.isLoading = false;
      });
    },

    onSave() {
      this.addLoading = true;

      const newAssignIds = this.assignIds.filter(id => !this.originalAssignIds.includes(id));

      const expectedType = this.type === 'department' ? 'department' :
          (this.type === 'company' ? 'company' : 'user');

      const removedAssignIds = this.originalAssignIds.filter(id => {
        const isRemoved = !this.assignIds.includes(id);
        const actualType = this.testsWithAssignType[id];
        const canRemove = actualType === expectedType;
        return isRemoved && canRemove;
      });

      if (newAssignIds.length === 0 && removedAssignIds.length === 0) {
        this.$snackbar.add({
          type: 'warning',
          text: this.$t('no_changes_to_save')
        });
        this.addLoading = false;
        return;
      }

      const promises = [];

      if (removedAssignIds.length > 0) {
        let deleteJson = {
          testIds: removedAssignIds,
        };

        if (this.type === 'company') {
          deleteJson.companyId = this.preData.companyId;
        }
        else if (this.type === 'department') {
          deleteJson.departmentId = this.selectedDepartment;
        }
        else {
          deleteJson.userId = this.preData.userId;
        }

        promises.push(
            testService.deleteTestAssign(deleteJson)
                .then(() => {
                })
        );
      }

      if (newAssignIds.length > 0) {
        let assignJson = {
          testIds: newAssignIds
        };

        if (this.type === 'company') {
          assignJson.companyId = this.preData.companyId;
        }
        else if (this.type === 'department') {
          assignJson.departmentId = this.selectedDepartment;
        }
        else {
          assignJson.userId = this.preData.userId;
        }

        promises.push(
            testService.assignTest(assignJson)
                .then(() => {
                })
        );
      }

      Promise.all(promises)
          .then(() => {
            const addedCount = newAssignIds.length;
            const removedCount = removedAssignIds.length;

            let message = '';
            if (addedCount > 0 && removedCount > 0) {
              message = this.$t('tests_updated_successfully', { added: addedCount, removed: removedCount });
            } else if (addedCount > 0) {
              message = this.$t('tests_assigned_successfully', { count: addedCount });
            } else if (removedCount > 0) {
              message = this.$t('tests_removed_successfully', { count: removedCount });
            }

            this.$snackbar.add({
              type: 'success',
              text: message
            });
            this.addLoading = false;
            this.lastLoadedCompanyId = null;
            this.lastLoadedUserId = null;
            this.lastLoadedDepartmentId = null;
            this.refreshCallback();
            this.onHide();
          })
          .catch(error => {
            this.addLoading = false;
            handleErrorResponse(error, this.$snackbar);
          });
    },

    formatDate(dateStr) {
      try {
        const currentLang = this.currentLocale === 'en' ? 'en' : 'tr';

        if (!dateStr) return '-';

        const date = new Date(dateStr);

        const formatter = new Intl.DateTimeFormat(currentLang === 'tr' ? 'tr-TR' : 'en-US', {
          day: '2-digit',
          month: 'short',
          year: 'numeric'
        });

        return formatter.format(date);

      } catch (e) {
        return '-';
      }
    },
  },

};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}
.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}

.search-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid #EAECF0;
  background-color: #F9FAFB;
  border-radius: 24px;
  margin-bottom: 20px;
}

.search-wrapper img {
  margin-left: 10px;
}

.search-input {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 10px;
  width: 100%;
}

.program-list {
  height: 100%;
  overflow-x: auto;
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.program-image {
  height: 80px;
  width: 120px;
  border-radius: 16px;
}

.program-tag {
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #101828;
  background-color: #E9EAEF;
  border-radius: 8px;
  padding: 3px 12px;
  margin-right: 5px;
  margin-bottom: 15px;
}

.program-row {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.program-row:hover {
  background-color: #f9fafb;
  border-radius: 16px;
}

.program-row.checked {
  border: 1px solid #3DA33E;
  background-color: #f5f5f5;
  border-radius: 16px;
}

.program-row.disabled {
  opacity: 0.7;
  cursor: not-allowed !important;
}

.program-row.disabled:hover {
  background-color: transparent !important;
}

.program-left {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}

.program-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.program-info .program-title {
  font-family: euclid_medium, sans-serif;
  font-size: 14px;
  color: #101828;
}

.program-info .program-text {
  font-size: 12px;
  color: #667085;
}

.program-right {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}

.program-right .program-date-text {
  font-size: 12px;
  color: #98A2B3;
  white-space: nowrap;
}

.loading-center {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

@media screen and (max-width: 768px) {
  .modal-content {
    width: 90%;
  }

  .program-right {
    display: none;
  }
}
</style>
